import React, { useRef, useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { profileAction } from "@redux/modules";
import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaCamera,
  FaImage,
  FaUpload,
} from 'react-icons/fa';

const ReceiptScan = () => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  // Basit selector
  const uploadInvoiceState = useSelector(
    (state) => state.profile?.uploadInvoice
  );

  const uploadErr = useSelector((state) => state.profile?.error);

  console.log(uploadErr);

  // Memoize edilmiş değerler
  const { InvoiceData, error: uploadError } = useMemo(() => {
    return {
      InvoiceData: uploadInvoiceState?.InvoiceData || null,
      error: uploadInvoiceState?.error || null,
    };
  }, [uploadInvoiceState]);

  const cameraInputRef = useRef();
  const galleryInputRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (uploadError) {
      showErrMessage("Fiş yüklenirken bir hata oluştu.");
      setShowErrorModal(true);
    } else if (InvoiceData) {
      showMessage("Fiş başarıyla yüklendi!");
      setUploadedFile(null);
      setShowSuccessModal(true);
    }
  }, [InvoiceData, uploadError]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadedFile(file);
    setError(null);
    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await dispatch(profileAction.uploadInvoice(formData));
      console.log(response);
      if (response && response.id) {
        showMessage("Fiş başarıyla yüklendi!");
        setUploadedFile(null);
        setShowSuccessModal(true);
      } else {
        console.log(response);
        setError(uploadErr.message);
        setShowErrorModal(true);
      }
    } catch (err) {
      setError(err.message);
      setShowErrorModal(true);
    } finally {
      setIsUploading(false);
    }
  };

  const handlePhotoButtonClick = () => {
    setShowModal(true);
  };

  const handleSelect = (type) => {
    setShowModal(false);
    if (type === "camera") {
      cameraInputRef.current.click();
    } else if (type === "gallery") {
      galleryInputRef.current.click();
    }
  };

  return (
    <div className="container-fluid py-4">
      {/* Başlık ve Açıklama */}
      <div className="row mb-4">
        <div className="col-12">
          <h2 className="mb-3">Fiş Yükleme</h2>
          <div className="card bg-light border-0 p-4">
            <div className="row">
              <div className="col-md-8">
                <h5 className="mb-3">Fiş Yükleme Nasıl Çalışır?</h5>
                <ol className="mb-0">
                  <li className="mb-2">
                    Market, kafe veya restoran fişinizi fotoğraflayın veya PDF
                    olarak yükleyin
                  </li>
                  <li className="mb-2">
                    Sistem otomatik olarak fişinizi işleyecek ve bilgileri
                    çıkaracaktır
                  </li>
                  <li className="mb-2">
                    Yüklenen fişler otomatik olarak kampanyalara dahil
                    edilecektir
                  </li>
                  <li>
                    Fişlerinizi "Fiş ve Faturalarım" sayfasından takip
                    edebilirsiniz
                  </li>
                </ol>
              </div>
              <div className="col-md-4">
                <div className="bg-white p-3 rounded shadow-sm">
                  <h6 className="mb-3">Desteklenen Formatlar</h6>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="fa fa-check text-success me-2"></i>
                      JPG, JPEG
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-check text-success me-2"></i>
                      PNG
                    </li>
                    <li>
                      <i className="fa fa-check text-success me-2"></i>
                      PDF
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Fiş Yükle Alanı */}
      <div className="row justify-content-center">
        <div className="col-12 ">
          <div className="card shadow-sm p-4">
            <h4 className="mb-3 text-primary text-center">
              <i className="fa fa-upload me-2"></i>Fiş Yükle
            </h4>
            <button
              type="button"
              className="btn btn-outline-primary w-100 py-4 d-flex flex-column align-items-center justify-content-center"
              style={{ minHeight: 200, borderStyle: "dashed" }}
              onClick={handlePhotoButtonClick}
              disabled={isUploading}
            >
              {isUploading ? (
                <>
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Yükleniyor...</span>
                  </div>
                  <span className="mb-2 text-center">Fiş Yükleniyor...</span>
                </>
              ) : (
                <>
                  <FaCamera
                    className="mb-3 text-secondary"
                    style={{ fontSize: "2rem" }}
                  />
                  <span className="mb-2 text-center">
                    Fotoğraf çek veya yükle
                  </span>
                  <span className="text-muted" style={{ fontSize: 13 }}>
                    Desteklenen formatlar: <b>JPG, PNG, PDF</b>
                  </span>
                </>
              )}
            </button>

            <input
              ref={cameraInputRef}
              type="file"
              accept="image/*,.pdf"
              capture="environment"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <input
              ref={galleryInputRef}
              type="file"
              accept="image/*,.pdf"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            {error && (
              <div className="alert alert-danger mt-3 py-2 text-center">
                {error}
              </div>
            )}

            {uploadedFile && !isUploading && (
              <div className="mt-3 small text-success text-break text-center fw-bold">
                Yüklenen dosya: {uploadedFile.name}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Seçim Modalı */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.3)",
            zIndex: 9999,
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title">Fotoğraf Seçimi</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <button
                  className="btn btn-outline-primary w-100 mb-3"
                  onClick={() => handleSelect("camera")}
                >
                  <FaCamera className="me-2" /> Fotoğraf Çek
                </button>
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => handleSelect("gallery")}
                >
                  <FaImage className="me-2" /> Fotoğraf/PDF Yükle
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Başarı Modalı */}
      {showSuccessModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.3)",
            zIndex: 10000,
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4 text-center">
              <div className="modal-body">
                <FaCheckCircle
                  className="text-success mb-3"
                  style={{ fontSize: "3rem" }}
                />
                <h4 className="mb-3">Fiş başarıyla yüklendi!</h4>
                <p className="text-muted mb-4">
                  Fişiniz sisteme başarıyla kaydedildi. Dilerseniz yeni bir fiş
                  yükleyebilirsiniz.
                </p>
                <button
                  className="btn btn-primary w-100"
                  onClick={() => setShowSuccessModal(false)}
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hata Modalı */}
      {showErrorModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.3)",
            zIndex: 10000,
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4 text-center">
              <div className="modal-body">
                <FaTimesCircle
                  className="text-danger mb-3"
                  style={{ fontSize: "3rem" }}
                />
                <h4 className="mb-3">Fiş Yüklenemedi!</h4>
                <p className="text-muted mb-4">{error}</p>
                <button
                  className="btn btn-danger w-100"
                  onClick={() => setShowErrorModal(false)}
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceiptScan;
